// removed by extract-text-webpack-plugin
module.exports = {"toggleButton":"ToggleButton__toggleButton__vUlIB","on":"ToggleButton__on__2BLJq"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Common/ToggleButton/ToggleButton.scss
// module id = 1648
// module chunks = 0